import { PropsWithChildren } from 'react'
import { useThemeSwitch } from 'hooks/theme'

export interface ICloseModalIconProps {
  fill?: string
  active?: boolean
}

export const CloseModalIcon = ({ fill, active }: PropsWithChildren<ICloseModalIconProps>) => {
  const { mode } = useThemeSwitch()

  return <>{mode === 'light' ? <DarkModeCloseModalIcon /> : <LightModeCloseModalIcon />}</>

  function LightModeCloseModalIcon() {
    return (
      <svg width="24" height="24" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.4" d="M41.25 22.5C41.25 32.8553 32.8553 41.25 22.5 41.25C12.1447 41.25 3.75 32.8553 3.75 22.5C3.75 12.1447 12.1447 3.75 22.5 3.75C32.8553 3.75 41.25 12.1447 41.25 22.5Z" fill="#444854"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M26.8095 28.7982C27.3587 29.3474 28.2491 29.3474 28.7983 28.7982C29.3474 28.2491 29.3474 27.3587 28.7983 26.8095L24.4894 22.5007L28.7982 18.1919C29.3474 17.6427 29.3474 16.7523 28.7982 16.2031C28.2491 15.654 27.3587 15.654 26.8095 16.2031L22.5007 20.5119L18.1917 16.2029C17.6425 15.6537 16.7521 15.6537 16.2029 16.2029C15.6537 16.7521 15.6537 17.6425 16.2029 18.1916L20.512 22.5007L16.2029 26.8097C15.6537 27.3589 15.6537 28.2493 16.2029 28.7985C16.7521 29.3477 17.6425 29.3477 18.1916 28.7985L22.5007 24.4894L26.8095 28.7982Z" fill="#444854"/>
      </svg>
    )
  }

  function DarkModeCloseModalIcon() {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        fill="url(#paint0_angular_2204_50278)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.2986 15.3591C14.5915 15.652 15.0663 15.652 15.3592 15.3591C15.6521 15.0662 15.6521 14.5913 15.3592 14.2984L13.0617 12.0009L15.3591 9.70356C15.652 9.41066 15.652 8.93579 15.3591 8.6429C15.0662 8.35 14.5913 8.35 14.2984 8.6429L12.0011 10.9402L9.70237 8.64155C9.40948 8.34865 8.93461 8.34865 8.64171 8.64155C8.34882 8.93444 8.34882 9.40931 8.64171 9.70221L10.9404 12.0009L8.64154 14.2998C8.34865 14.5926 8.34865 15.0675 8.64154 15.3604C8.93444 15.6533 9.40931 15.6533 9.70221 15.3604L12.0011 13.0616L14.2986 15.3591Z"
        fill="url(#paint1_angular_2204_50278)"
      />
      <defs>
        <radialGradient
          id="paint0_angular_2204_50278"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12 16.6045) rotate(23.0257) scale(10.6261 42.7981)"
        >
          <stop offset="0.0001" stop-color="#DDDDDD" />
          <stop offset="0.927083" stop-color="white" />
        </radialGradient>
        <radialGradient
          id="paint1_angular_2204_50278"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.0004 13.649) rotate(23.0291) scale(3.80267 15.3175)"
        >
          <stop offset="0.0001" stop-color="#DDDDDD" />
          <stop offset="0.927083" stop-color="white" />
        </radialGradient>
      </defs>
    </svg>
    )
  }
}
